/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { ITableData, ITableLabelsData } from '../types';

interface ITableLabelItemResponse {
    color: string;
    id: number;
    name: string;
}

type ITableLabelsDataResponse = Pick<ITableData<ITableLabelItemResponse>, 'elements'>

export const mapTableLabelsListResponse = (response: ITableLabelsDataResponse): ITableLabelsData =>
    response?.elements?.map(label => ({
        value: label.id,
        label: label.name,
        color: 'color' + label.color,
    })) ?? [];
